import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100">
      <div className="p-8 max-w-md text-center bg-white rounded-lg shadow-md">
        <h1 className="mb-4 text-6xl font-bold text-red-500">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-gray-800">
          Page Not Found
        </h2>
        <p className="mb-6 text-gray-600">
          The page you are looking for doesnt exist or has been moved.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-4 py-2 text-white bg-blue-500 rounded transition-colors hover:bg-blue-600"
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
